import React, { Component } from "react";
import Iframe from "react-iframe";
import QRCode from "qrcode.react";
import "rc-color-picker/assets/index.css";
import TextField from "material-ui/TextField";
import LinearProgress from "../components/LinearProgress";
import Paper from "material-ui/Paper";
import firebase from "../firebase";
import URLQrCode from "../components/URLQrCode";

const styles = {
  root: {
    padding: 20,
    margin: "0 auto",
  },
  paper: {
    padding: 20,
  },
};

class QrCodes extends Component {
  state = {
    webAppUrl: null,
    photo: null,
    loading: true,
  };

  async componentDidMount() {
    const { params } = this.props;

    const restaurantId = params && params.restaurantId;
    this.restaurantPath = firebase
      .firestore()
      .collection("restaurant")
      .doc(restaurantId);

    try {
      const restaurantSnap = await this.restaurantPath.get();

      const restaurant = restaurantSnap.data();

      this.setState({
        ...restaurant,
        restaurantId,
        loading: false,
      });
    } catch (e) {
      console.log({ e });
      this.setState({
        loading: false,
      });
    }
  }

  render() {
    const { params } = this.props;
    const restaurantId = params && params.restaurantId;

    const { loading, webAppUrl, photo } = this.state;
    const appPreviewUrl = `https://chowreach.web.app/?restaurantId=${restaurantId}`;
    const qrUrl = webAppUrl || appPreviewUrl;

    if (loading) return <LinearProgress />;

    return (
      <div style={styles.root}>
        <h1>QR Codes</h1>

        <h2>Menu QR Code</h2>
        <Paper style={{ padding: 15 }}>
          <URLQrCode url={qrUrl} label="Menu QR Code" />
        </Paper>
        <h2>Menu preview</h2>
        <Paper style={{ padding: 15 }}>
          <Iframe
            url={appPreviewUrl}
            width="337px"
            height="600px"
            id="appPreview"
            display="block"
            position="relative"
            title="App Preview"
            allowFullScreen
          />
        </Paper>
      </div>
    );
  }
}

export default QrCodes;



// WEBPACK FOOTER //
// ./src/pages/QrCodes.js